(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("textik_vendor"));
	else if(typeof define === 'function' && define.amd)
		define(["textik_vendor"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("textik_vendor")) : factory(root["textik_vendor"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_10__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// webpack/universalModuleDefinition